<script>
import { store } from './store.js'

export default {
  props: ['item'],
  data() {
    return {
      store
    }
  },
  mounted() {
  },
  updated() {
    
  },

   computed: {
    // a computed getter
    mediaId() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

	mediahiddenId() {
      var output = this.item.id + '-media-id'; 
      return  output;
    },

    mediaDiv() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

	computedHeight() {
		return Math.round(this.item.frame.height);
	},

  },

  methods: {
  }
};
</script>

<template>
					<div class="og-inside">
						<div class="tabs">
							<ul>
								<li><a href="#tab-01">Data</a></li>
								<li><a href="#tab-02">Position</a></li>
							</ul>
							<div id="tab-01">
								<div class="form-wrap">
									<div class="og-form-fields-row">
										<div class="og-form-field">
											<p class="hide-if-no-js">
												<a href="#" :id="mediaId" :data-layerid="this.item.id" aria-describedby="set-post-thumbnail-desc" class="imagebutton">
													<img :src="this.item.src"/>
													<input type="hidden" :id="mediahiddenId" :value="this.item.imgid" class="oghiddenid" />
												</a>
											</p>
											<p class="hide-if-no-js howto" id="set-post-thumbnail-desc">Click the image to edit or update</p>
										</div><!-- .og-form-field -->
									</div><!-- .og-form-fields-row -->
								
								<h3 class="">Border</h3>

									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
												<label>Width</label>
												<input v-model="item.borderwidth" placeholder="width" min="0" type="number">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Style</label>
												<select v-model="item.borderstyle">
													<option value="solid">Solid</option>
													<option value="double">Double</option>
													<option value="dotted">Dotted</option>
													<option value="dashed">Dashed</option>
												</select>			
											</div>
									</div>

									<div class="og-form-fields-row">
											<div class="og-form-field og-form-field-half">
												<label>Color</label>
												<input v-model="item.bordercolor" placeholder="color" type="color">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Radius</label>
												<input v-model="item.borderradius" placeholder="width" min="0" type="number">
											</div>
									</div>

								</div><!-- .form-wrap -->
							</div>
							<div id="tab-02">
								<div class="form-wrap">
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="width">Width</label>
											<input v-model="this.item.frame.width" type="number">
										</div>
										<div class="og-form-field og-form-field-half">
											<label for="width">Height</label>
											<input v-model="computedHeight" type="number" disabled>
										</div>
									</div>
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-third">
											<label for="width">Top</label>
											<input v-model="this.item.frame.translatey" type="number">
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="height">Left</label>
											<input v-model="this.item.frame.translatex" type="number">
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="rotation">Rotation</label>
											<input v-model="this.item.frame.rotate" type="number">
										</div>
									</div>
								</div><!-- .form-wrap -->
							</div>
							
						</div><!-- .tabs -->
					</div><!-- .inside -->
			

</template>